export default {
  // 浏览器标签页标题（正式域名下由域名决定语言，见 src/i18n/domains.js；本地开发随站内切换实时更新）
  pageTitle: '深圳可孚生物科技有限公司',
  // 分享卡片标题（og:title；静态 HTML 中由构建模式 build:cn 输出，见 public/index.html）
  pageShareTitle: '深圳可孚生物科技有限公司',
  // 页面描述（meta description / og:description；静态 HTML 中由构建模式 build:cn 输出，见 public/index.html）
  pageDescription: '把握自我节奏，拥抱健康生活。',
  // 导航菜单
  nav: {
    home: '首页',
    product: '产品介绍',
    service: '服务与支持',
    download: '下载中心',
    about: '关于我们'
  },
  // 语言切换
  lang: {
    zh: '简体中文',
    en: 'English'
  },
  // 首页
  home: {
    smallword1: '实时守护',
    smallword2: '远程关怀',
    smallword3: '免扎手指',
    heroTitle: '可孚孚探®',
    heroSubtitle: '持续葡萄糖监测系统',
    heroBtn: '了解更多',
    serviceTitle: '服务与支持',
    serviceDesc: '可孚具备专业的医学服务生态，提供院内、院外血糖管理\n方案，帮助用户提升血糖管理水平，助力医疗机构建设数\n字化全院血糖管理系统。',
    serviceBtn: '点击查看',
    missionTitle: '我们的使命',
    missionDesc: '用科技加速私人医疗发展\n|让健康平等属于每一个人',
    shareTitle: '呵护您的健康 是我们不变的初心',
    shareSubtitle: '尊重用户体验 追求极致品质',
    shareDesc: '可孚永远将用户体验放在首位，我们的产品不仅融入最新技术，更\n基于用户痛点，面向用户研发。可孚孚探对于改变慢病管理的探索\n从未停滞，致力于重新定义慢病产品体验，做用户认可的质价比产\n品。',
    modeTitle: '业务遍布全球市场',
    modeDesc: '深耕医疗器械赛道，布局全球化市场格局，公司业务辐射全球各大洲，深谙各国医疗器械法规标准与临床使用场\n景，具备完善国际认证、跨境物流、本地化售后体系助力全球医疗体系升级，共建普惠健康生态。',
    extraTitle: '全线品质严格管控',
    extraCardTitle: '优秀的团队',
    extraCardDesc: '我们汇聚硬件、软件、算法等多领域专业人\n才，从产品立项到落地全程质检把控，力求品\n质零瑕疵。所有设备自主原创设计、内部独立\n研发，面向全球市场发售，持续为用户提供顶\n尖品质保障。'
  },
  // 产品介绍页
  product: {
    title: '可孚孚探',
    subtitle: '持续葡萄糖监测系统',
    hourText: 'Hour',
    dayText: 'Day',
    feature1: '全天候监测，14天的贴身血糖管家',
    feature2: '每日趋势，一览无遗',
    feature3: '手机APP上随时关注血糖数据，控糖更及时',
    painlessTitle: '无痛佩戴 更舒适',
    painlessDesc: '一体设计 操作简便\n|柔性软针 佩戴舒适',
    bluetoothTitle: '蓝牙5.0传输',
    bluetoothSubtitle: '24小时稳定监测\n|实时更新血糖状态',
    calibTitle: '无需校准 更方便',
    calibDesc: '无需扎手指就能校准\n|减少采血次数',
    compactDesc: '重量仅≈3g\n|IP28级防水防尘',
    reportTitle: '数据查看简单易懂',
    reportDesc: '专业图谱报告生成\n|助力轻松无忧控糖',
    compactTitle: '小巧体积 佩戴便携',
    compactSubtitle: '佩戴上手 存在感低',
    sceneTitle: '适用不同的应用场景 不惧挑战',
    sceneSubtitle: '控糖≠控自由',
    sceneSport: '运动',
    sceneShower: '淋浴',
    sceneSwim: '游泳',
    sceneWork: '工作',
    sceneDaily: '日常',
    sceneSleep: '睡眠',
    heroTitle: '可孚孚探®',
    heroSubtitle: '持续葡萄糖监测系统',
    heroDesc: '14天连续动态监测，无需频繁扎手指，更无需手动扫描。手机\nApp实时呈现血糖曲线，全天候掌控波动趋势。\n可孚孚探，用科技减负日常，让每一次饮食、运动都有据可依，\n助你稳稳守住健康防线。',
    recordTitle: '轻松记录 控糖打卡',
    recordSubtitle: '合理规划 实现餐饮/运动控糖',
    agpTitle: '更精准的糖尿病管理',
    agpSubtitle: '糖尿病精细化、科学化健康管控',
    agpPoint1: 'CGM指南一致推荐住院患者采用持续葡萄糖监测系统进行血糖监测与血糖控制',
    agpPoint2: '记录和分析患者葡萄糖数据并生成患者持续葡萄糖AGP报告，让医生更全面了解患者实时血糖情况',
    agpPoint3: '血糖管理数据共享，方便医生随时了解患者的病情变化，指导治疗方案的调整',
    analysisTitle: '血糖分析 周期回顾',
    analysisSubtitle: '佩戴完成自动生成“周期血糖报告”',
    expertTitle: '专家级血糖报告',
    expertPoint1: '实时监测数据配合详尽统计，血糖指标一目了然。',
    expertPoint2: '标准化血糖报告生成配合完备指标评估，助力您的控糖之旅。',
    cardAvgLabel: '平均葡萄糖水平',
    cardAvgUnit: 'MG',
    cardAvgValue: '6.4',
    cardAvgUnit2: 'mmol/L',
    cardAvgTarget: '建议控制目标 <6.6',
    cardHbLabel: '预估糖化血红蛋白',
    cardHbUnit: 'eHbA1c',
    cardHbValue: '5.8',
    cardHbPercent: '%',
    cardHbTarget: '建议控制目标 <7%',
    modelTitle: '三大模式 随意切换',
    modelSubtitle: '适用不同的用户群体 上手无压力',
    modePro: '专业模式',
    modeProDesc: '专业模式为普通佩戴者打造，完整提供血糖实时监测、AGP 标准化报告、事件记录、周期回顾、数据统计分析等全部核心功能。清晰展示血糖波动曲线与各项指标，帮助你全面掌握自身血糖变化，科学完成日常控糖管理。',
    modeFamily: '亲友模式',
    modeFamilyDesc: '亲友模式支持绑定多位家人亲友设备，远程查看对方实时血糖数值、周期报告与血糖波动状态。无需面对面，即可及时掌握亲友血糖动态，第一时间留意异常情况，远程守护家人血糖健康。',
    modeCare: '关怀模式',
    modeCareDesc: '关怀模式专为老年用户优化，放大界面字体、图标与操作控件，简化页面繁杂信息，重点血糖数据醒目展示。降低阅读与操作门槛，老人可以轻松读取血糖结果，简单上手完成血糖查看与基础管理。',
    officialShop: '可孚官方商城',
    shopTmall: '可孚医疗天猫商城',
    shopJd: '可孚医疗京东商城',
    shopPdd: '可孚医疗拼多多商城'
  },
  // 服务与支持页
  service: {
    title: '服务与支持',
    faqTitle: '常见问题',
    tutorialTitle: '产品使用教程',
    video1Label: '产品佩戴植入演示',
    video2Label: '产品连接APP端演示',
    scanQR: '扫一扫',
    followUs: '关注可孚孚探',
    afterSales: '咨询售后服务',
    heroEmail: 'kfft@cofoe.com',
    heroEmailLabel: '售后邮箱留言',
    heroPhone: '400-999-8788',
    heroPhoneLabel: '售后客服咨询',
    pdfEntry: '产品使用说明书（PDF）',
    videoNotSupport: '您的浏览器不支持视频播放',
    // 常见问题问答（faqQ为问题，faqA为答案，答案中\n换行由CSS渲染）
    faqQ1: '什么是CGMS?',
    faqA1: '持续葡萄糖监测系统（Continuous Glucose Monitoring System，简称 CGMS）是一种通过连续、实时监测人体组织间液葡萄糖浓度，来反映血糖水平的便携式医疗设备。它主要用于糖尿病患者的血糖管理，相比传统的指尖采血测量（即时血糖检测），能提供更全面、动态的血糖变化信息。',
    faqQ2: '可孚动态血糖仪使用周期是多久？',
    faqA2: '可孚动态血糖仪佩戴一次能够连续监测 14 天血糖值，每 5 分钟上传一个血糖数值，有助于分析血糖的动态变化趋势。',
    faqQ3: '如何正确选择佩戴位置？',
    faqA3: '经研究反馈，将传感器佩戴在上臂背侧有助于获得最佳的产品佩戴体验。我们不建议将可孚发射器佩戴在腹部、大腿、臀部、背部或日常活动及体育锻炼的热点肌肉区域，这可能导致传感器意外脱落。请确保佩戴位置的洁净，避免使用身体乳霜等产品，因为它们会干扰传感器的读数并影响胶贴的附着力。理想的佩戴区域应该没有胎记、妊娠纹或其他肿块，表面光滑平整，理想的敷贴位置应位于上臂背侧。',
    faqQ4: '可孚动态血糖仪适用人群？',
    faqA4: '可孚动态血糖仪适用人群包括：\n1. 糖尿病患者：包括 1 型（需调整胰岛素等）、2 型（用胰岛素 / 控制不佳者）、妊娠期糖尿病患者；\n2. 血糖异常未确诊人群：糖尿病前期者、有低血糖风险者；\n3. 其他场景：健康人群自我管理（如调整饮食）、特殊医疗场景（如手术前后）。',
    faqQ5: '我可以自己佩戴吗？',
    faqA5: '可以自己佩戴可孚动态血糖仪，流程简单，无需专业医护人员协助，佩戴前请仔细阅读说明书和快速指南，按快速指南指引操作即可。',
    faqQ6: '佩戴是否有痛感？',
    faqA6: '我们的传感器采用微创软针探头，大多数使用者完全感觉不到佩戴时的疼痛，少数人会有较轻微痛感，它会随着时间推移减轻。若佩戴12小时后仍有痛感，请立即联系可孚孚探客服。',
    faqQ7: '洗澡时需要摘下吗？',
    faqA7: '不需要，产品具有IP28等级防水能力。可孚发射器可以应对日常的洗浴和游泳场景。',
    faqQ8: '可孚动态血糖仪断连需怎么处理？',
    faqA8: '可孚动态血糖仪断连处理要点：\n1. 通过App重新连接或唤醒设备；\n2. 检查设备贴合度，重启蓝牙并重新配对；\n3. 确保在有效距离内，远离干扰源；\n4. 排查电量、更新软件版本；\n5. 重启手机或更换手机并重新配对；\n6. 若以上方法均尝试后仍无法正常连接，请联系客服，更换传感器。'
  },
  // 下载中心页
  download: {
    title: '可孚孚探APP',
    subtitle: '持续葡萄糖监测应用',
    desc: '不止于监测反馈，可孚孚探APP内更提供一站式数据统计与标准化血糖报告可供您免费查看，旨在将智慧个护新体验，带到您的身边。',
    scanTip: '手机扫码下载\n"可孚孚探"APP',
    videoIOS: 'APP（iOS）下载教程',
    videoAndroid: 'APP下载教程',
    videoHarmony: 'APP（鸿蒙）下载教程',
    videoNotSupport: '您的浏览器不支持视频播放',
    // 模块四文字
    mod4Title: '产品安装教程',
    mod4Subtitle: 'APP现已上架各大应用市场，用户可直接扫码下载。',
    // 模块二文字
    mod2Title: '不止于监测 更是血糖分析大师',
    mod2Subtitle: '不仅提供常态化血糖监测，可孚孚探App还可以根据用户行为及使用情况提供定制化分析与报告反馈，让血糖管理更贴近你的生活轨迹。',
    feature1: '更方便快捷地查看佩戴周期内的血糖达标情况，血糖状况一览无遗',
    feature2: '实时血糖监测，每五分钟更新一次，随时查看当前最新血糖值和剩余可佩戴时长',
    feature3: '免费生成佩戴周期内的标准化血糖报告，不仅包含基础统计，更涵盖进阶专业数据反馈',
    feature4: '多日血糖曲线，可以直观回顾和对比往日血糖变化，成为您最专业的随身控糖助手',
    // 模块三文字
    mod3Title: '多方面的分析 更优秀的管理',
    mod3Subtitle: '通过血糖的每日分析、周期回顾、事件记录打卡，直接从佩戴周期和生活的多方面进行分析，使管理血糖时更轻松、更准确',
    mod3CardTitle1: '每日分析',
    mod3CardSubtitle1: '日夜血糖波动\n变化，尽收眼\n底',
    mod3CardTitle2: '周期回顾',
    mod3CardSubtitle2: '14天周期血糖\n指数综合分析\n一键生成专业\n血糖报告',
    mod3CardTitle3: '事件记录',
    mod3CardSubtitle3: '记录饮食、用\n药、胰岛素注\n射等数据展\n示前后血糖波\n动变化',
    mod3CardTitle4: '个人中心',
    mod3CardSubtitle4: '轻松管理血糖\n设备、亲友共\n享'
  },
  // 关于我们页
  about: {
    title: '关于我们',
    heroTitle: '品质无止境 服务无边界',
    heroSubtitle: '客户满意才是我们的成功',
    heroBtn: '加入我们',
    introTitle: '关于我们',
    introSubtitle: 'About us',
    companyName: '深圳可孚生物科技有限公司',
    companyDesc: '深圳可孚生物科技有限公司坐落于深圳市宝安区，占地面积约3000平方米，是一家集研发创新、生产制造、市场销售、售后服务于一体的高新技术企业。公司专注于持续葡萄糖监测系统（CGMS）的核心技术研发与规模化生产，深耕精准医疗与健康监测领域，坚持以技术创新为驱动，以品质制造为根基，为全球用户提供安全、稳定、专业的血糖监测解决方案。目前，公司业务已覆盖海内外多个国家和地区，致力于成为全球领先的持续葡萄糖监测领域标杆企业。',
    iconLabel1: '研发',
    iconLabel2: '设计',
    iconLabel3: '生产',
    devTitle: '发展历程',
    devYear1: '2026',
    devDesc1: '自主研发的持续葡萄糖监测系统获国家药监局批准，拿到三类医疗器械注册证。后陆续拿到该款CGM产品的生产许可、广告审查批准文号，同时新增多项外观专利和配套软件著作权。',
    devYear2: '2025',
    devDesc2: '累计拥有专利约70项、软件著作权12项，核心技术围绕生物传感、血糖监测传感器方向布局。',
    devYear3: '2024',
    devDesc3: '公司被认定为省级创新新型中小企业，同期开始批量取得各类专利授权。',
    devYear4: '2021',
    devDesc4: '由可孚医疗科技股份有限公司投资设立，为全资子公司',
    contactTitle: '联系我们',
    afterSalesTitle: '售后服务',
    afterSalesEmail: '邮箱：',
    afterSalesEmailValue: 'kfft@cofoe.com',
    afterSalesPhone: '电话：',
    afterSalesPhoneValue: '400-999-8788',
    businessTitle: '商务联系',
    businessEmail: '邮箱：',
    businessEmailValue: 'CGM.sales@szcofoe.com',
    businessPhone: '电话：',
    businessPhoneValue: '0755-2331-6007',
    qrLabel1: '扫一扫\n关注可孚孚探',
    qrLabel2: '扫一扫\n咨询售后服务',
    addressTitle: '公司地址',
    addressDesc: '深圳市宝安区西乡街道固兴社区航城大道中德欧产业示范园C栋C203'
  },
  // 加入我们页join us
  join: {
    hotJobs: '热招岗位',
    back: '← 返回',
    applyNow: '立即投递',
    jobs: {
      register: '国际注册工程师',
      backend: '后台开发工程师',
      tester: '传感器研发工程师',
      sales: '高级嵌入式软件工程师',
      trade: '生产技术员',
      regSpecialist: '海外销售',
      embedded: '工艺开发工程师'
    },
    contactTitle: '联系方式',
    nameLabel: '姓名',
    namePh: '请输入您的姓名',
    phoneLabel: '电话',
    phonePh: '请输入您的电话',
    emailLabel: '邮箱',
    emailPh: '请输入您的邮箱',
    uploadTitle: '上传简历',
    uploadTip: '将您的 PDF 文件在此处上传并提交，以便进行职位匹配！',
    uploadLimit: '仅支持 .pdf 文件，单个文件大小不得超过 5M',
    submit: '提交',
    errName: '请输入您的姓名',
    errPhone: '请输入您的电话',
    errPhoneFormat: '请输入正确的电话号码',
    errEmail: '请输入您的邮箱',
    errEmailFormat: '请输入正确的邮箱地址',
    errFile: '请上传简历',
    errFileType: '仅支持 .pdf 文件',
    errFileSize: '文件大小不得超过 5M',
    errServer: '提交失败，请稍后重试',
    successTitle: '投递成功',
    successDesc: '您的简历已安全抵达我们的人才库。每一份申请我们都会认真阅读，请耐心等待回复。下一步若匹配，我们会主动联系您；在此期间，欢迎继续了解我们。',
    successOk: '好的'
  },
  // 页脚
  footer: {
    company: '可孚',
    home: '首页',
    homeSub: '可孚孚探',
    product: '产品介绍',
    productSub1: '持续葡萄糖监测系统',
    productSub2: '线上商城',
    service: '服务与支持',
    serviceSub1: '客户服务',
    serviceSub2: '用户手册',
    serviceSub3: '常见问题',
    download: '下载中心',
    downloadSub1: 'Android 客户端',
    downloadSub2: 'iOS 客户端',
    downloadSub3: 'Harmony OS 客户端',
    about: '关于我们',
    aboutSub1: '公司简介',
    aboutSub2: '联系我们',
    copyright: 'copyright@2025 深圳可孚生物科技有限公司',
    icp: '粤ICP备202536139号-1',
    privacy: '隐私政策与条款',
    // 隐私政策链接：中文站指向国内接口
    privacyUrl: 'https://api.szcofoe.com/app/article/privacy-policy/info?language=zh-CN'
  }
}
